export enum PaymentMethod {
  CREDIT_CARD = 'credit_card',
  PIX = 'pix',
  BANK_SLIP = 'bank_slip',
}
